import React from "react";
import localeText from "../../../../locale";
import { formatStatus } from "./orderDetailsUtils";

const OrderDetailsBuyerInfoPanel = ({
  status,
  currentOrder,
  isPhysicalProduct,
  parcelInfo,
  sales,
}) => {
  if (!currentOrder) return null;

  const showProductYetToBeShipped =
    !sales && status === "PAID" && !currentOrder?.pickinaddress && isPhysicalProduct && !parcelInfo;

  const showSellerPreparing =
    !sales &&
    ((status === "PAID" && currentOrder?.pickinaddress) ||
      (status === "SENT" && currentOrder?.pickinaddress)) &&
    isPhysicalProduct &&
    !parcelInfo;

  const showWaitingBuyerWithdrawal =
    sales && status === "SENT" && currentOrder?.pickinaddress && isPhysicalProduct && !parcelInfo;

  if (
    !showProductYetToBeShipped &&
    !showSellerPreparing &&
    !showWaitingBuyerWithdrawal &&
    !(isPhysicalProduct && parcelInfo)
  ) {
    return null;
  }

  return (
    <div className="mb-4">
      {showProductYetToBeShipped && <p>{localeText("productIsYetToBeShipped")}</p>}
      {showSellerPreparing && <p>{localeText("sellerIsPreparingYourOrder")}</p>}
      {showWaitingBuyerWithdrawal && <p>{localeText("waitingForBuyerWithdrawal")}</p>}

      {isPhysicalProduct && parcelInfo && (
        <>
          <h4>{localeText("pickupInfo")}</h4>
          <hr />
          <div className="grid">
            <div className="lg:col-6 col-12">
              <label>
                <b>{localeText("status")}:</b>
              </label>
              <p>
                {parcelInfo?.tracking_state
                  ? localeText(formatStatus(parcelInfo.tracking_state))
                  : localeText("youDontHave")}
              </p>
            </div>
            <div className="lg:col-6 col-12">
              <label>
                <b>{localeText("shippingMethod")}:</b>
              </label>
              <p>{parcelInfo?.courier || localeText("youDontHave")}</p>
            </div>
            <div className="lg:col-6 col-12">
              <label>
                <b>{localeText("trackingNumber")}:</b>
              </label>
              <p>{parcelInfo?.shipping_code || localeText("youDontHave")}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderDetailsBuyerInfoPanel;

